// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__B4bky","index":"styles_index__38IZD"};